<template>
  <CRow>

    <GmapMap
        :center="{lat: 10.372877, lng: 105.433680}"
        :zoom="15"
        map-type-id="terrain"
        style="width: 100%; height: 800px"
        >
        <GmapMarker
            :key="'m'+index"
            v-for="(m, index) in markers"
            :position="m.position"
            :clickable="true"
            :options = "m.options"
            @click="toggleInfoWindow(m,i)"
        />

        <GmapCircle
            :key="'c'+index"
            v-for="(m, index) in markers"
            :center="m.position"
            :radius="m.radius"
            :options="m.options"
            :clickable="true"
            @click="toggleInfoWindow(m,i)"
        />

        <GmapMarker
            :key="'ca'+index"
            v-for="(m, index) in cartMarkers"
            :position="m.position"
            :clickable="true"
            :options = "m.options"
            @click="toggleInfoWindow(m,i)"
        />

        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
        </gmap-info-window>


        </GmapMap>
  </CRow>
</template>

<script>
import mapData from './land_price';
import cartData from './cart';

export default {
  name: 'LandMap',
  data () {
    return {
        markers: [],
        cartMarkers: [],
        showCart: true,
        infoWindowPos: null,
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
        	content: '',
            //optional: offset infowindow so it visually sits nicely on top of our marker
            pixelOffset: {
              width: 0,
              height: -35
            }
        }
    }
  },
  watch: {

  },
  methods: {
      getLatLongFromCoord(coordString) {
          if(!coordString) 
            return {lat: 0, lng: 0};

        var p = coordString.split('-');

        var lat = parseFloat(p[0]);
        var long = parseFloat(p[1]);

        return {
          lat: lat,
          lng: long
        }
      },

        toggleInfoWindow: function(marker, idx) {
            this.infoWindowPos = marker.position;
            this.infoOptions.content = marker.infoText;

            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
              this.infoWinOpen = !this.infoWinOpen;
            }
            //if different marker set infowindow to open and reset current marker index
            else {
              this.infoWinOpen = true;
              this.currentMidx = idx;

            }

        },

    

      initMapData () {
          for(var i=0; i<mapData.length; i++) {
              var item = mapData[i];
              console.log(item);

              if(item.type === 'circle') {
                item.position = this.getLatLongFromCoord(item.latlong);
                item.infoText = '<div id="content">' + item.street + "-" + item.ward + "-" + item.radius + ' tr/m2</div>';
                if(item.radius == '') {
                    item.radius = 5;
                }
                else {
                    item.radius = parseFloat(item.radius.replace(',','.'));
                }

                item.options = {
                    strokeColor: item.color,
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: item.color,
                    fillOpacity: 0.35,
                }

                this.markers.push(item);
              }
          }

          for(var i=0; i<cartData.length; i++) {
              var item = cartData[i];
              console.log(item);

                item.position = this.getLatLongFromCoord(item.latlong);
                item.infoText = '<div id="content">' + item.notes + ' </div>';

                item.options = {
                    icon: {
                        url: "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                    }
                }
                
                this.cartMarkers.push(item);
              
          }
      }
  },
  mounted () {
      this.initMapData();
  }
}
</script>

<style scoped>
iframe {
  width: 100%;
  height: 800px;
}
</style>
